import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Form } from 'react-bootstrap'
import DeleteBtn from '../../../buttons/DeleteBtn'
import ProductDocuments from '../productsAuxForm/ProductDocuments'
import { articlesApi } from '../../../../api/articlesApi'
import Swal from 'sweetalert2'
import { swalTitle } from '../../../../constantes/swalTitle'
import {
  swalAlertError,
  swalAlertIsConfirm,
  swalSuccessGeneral,
  swalLoading,
} from '../../../../utils/swalAlert'
import _ from 'lodash'

const EditProductDocuments = ({ id, thereuploadFiles, inputs }) => {
  const allTypesOfDocuments = useSelector((state) => state.typesOfDocuments)

  const [docs, setDocs] = useState([])
  const [newDocs, setNewDocs] = useState([])
  const [reload, setReload] = useState(false)

  useEffect(() => {
    getAllDocumentsProduct(id)
  }, [])

  const getAllDocumentsProduct = async (id) => {
    const resp = await articlesApi.getalldocuementscascadeupper(id)
    if (resp.data.length > 0) {
      setDocs(resp.data)
    }
  }

  const handleSubmitArticleDocs = async (event) => {
    event.preventDefault()
    try {
      swalLoading(swalTitle.Loading)

      if (!_.isEmpty(newDocs)) {
        const thereAreDocs = newDocs.filter((doc) => doc.docs.length > 0)
        if (thereAreDocs.length > 0) {
          thereAreDocs.map(async (doc) => {
            try {
              const formData = new FormData()
              if (doc.docs.length > 0) {
                doc.docs.map((file) => formData.append('files[]', file))
              }
              formData.append('id_TiposDocumentos', doc.id_TiposDocumentos)
              formData.append('id_Articulo', id)
              formData.append('isDocument', true)
              await articlesApi.uploadFiles(formData)
              getAllDocumentsProduct(id)
            } catch (error) {
              swalAlertError(
                'Error con la subida del documento' + error.response.data ||
                  error.response.statusText,
              )
            }
          })
        }
      }
      setReload(true)
      setNewDocs([])
      await swalSuccessGeneral(swalTitle.Actualizado)
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const uploadDocs = (documents, typeDoc) => {
    const docsInfo = {
      id_TiposDocumentos: typeDoc,
      docs: documents,
    }
    newDocs.length > 1
      ? //Actualizar el estado de un objeto dentro de un array
        newDocs.map((elem) => {
          if (elem !== undefined) {
            if (elem.id_TiposDocumentos === typeDoc) {
              setNewDocs(
                newDocs.map((object) => {
                  if (object.id_TiposDocumentos === typeDoc) {
                    return {
                      ...object,
                      id_TiposDocumentos: typeDoc,
                      docs: documents,
                    }
                  }
                  return object
                }),
              )
            }
          }
        })
      : setNewDocs((newDocs) => [...newDocs, docsInfo])
    thereuploadFiles(documents)
  }

  const thereAreNewDocsAdded = () => {
    const isEmptyNewDocs = newDocs.filter((doc) => doc.docs.length > 0)
    return isEmptyNewDocs.length > 0 ? true : false
  }

  const handleRemoveArticleDocument = async (event, id_ArticuloDocumento) => {
    event.preventDefault()
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar el documento del producto?',
      )

      if (alert.isConfirmed) {
        swalLoading(swalTitle.Loading)
        const response = await articlesApi.deleteArticlesDocuments(
          id_ArticuloDocumento,
        )
        setDocs(
          docs.filter(
            (item) => item.id_ArticuloDocumento !== id_ArticuloDocumento,
          ),
        )
        Swal.close()
        swalSuccessGeneral(swalTitle.Eliminado, response.data)
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  return (
    <div className='task__container'>
      <div className='section-separator' />

      <h2 className='mb-10 products__subtitle'>Documentos adjuntos</h2>

      {/* Grid de documentos adjuntos - 3 columnas */}
      <div className='documents-grid'>
        {allTypesOfDocuments.length > 0
          ? allTypesOfDocuments.map((typeDoc, i) => (
              <div className='document-field' key={i}>
                <Form.Group size='lg'>
                  <Form.Label className='form__labels'>
                    {typeDoc.nombre}
                  </Form.Label>
                </Form.Group>
                {docs.length > 0 ? (
                  docs.map((doc, i) => {
                    if (doc.id_TipoDocumento == typeDoc.id_TipoDocumentos) {
                      return (
                        <div className='document-item' key={i}>
                          <div className='document-content'>
                            {parseInt(id) === doc.id_Articulo ? (
                              <>
                                <span className='document-name'>
                                  {doc.nombreDocumento}
                                </span>
                                <button
                                  className='delete-btn'
                                  onClick={(e) =>
                                    handleRemoveArticleDocument(
                                      e,
                                      doc.id_ArticuloDocumento,
                                      'doc',
                                    )
                                  }
                                >
                                  <DeleteBtn />
                                </button>
                              </>
                            ) : (
                              <>
                                <span className='document-name'>
                                  {doc.nombreDocumento}
                                </span>
                                <div className='document-source'>
                                  {doc.nombreArticulo}
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      )
                    }
                  })
                ) : (
                  <span className='no-documents'>No hay documentos</span>
                )}
              </div>
            ))
          : null}
          <ul className="product-file-list">
            {Array.isArray(inputs?.documents)
              && inputs?.documents?.map((doc, idx) => <li key={idx}>{doc}</li>)
            }
          </ul>
      </div>
      <div className='section-separator' />
      <h2 className='mb-10 products__subtitle'>Actualizar documentos</h2>

      {/* Grid de actualización de documentos - 3 columnas */}
      <div className='documents-update-grid'>
        <ProductDocuments
          allTypesOfDocuments={allTypesOfDocuments}
          uploadDocs={uploadDocs}
          reload={reload}
        />
      </div>

      <button
        className='btn save'
        onClick={(e) => handleSubmitArticleDocs(e)}
        disabled={!thereAreNewDocsAdded()}
      >
        Guardar
      </button>
    </div>
  )
}
export default EditProductDocuments
